import { render, staticRenderFns } from "./DailyPublishQuotaNotice.vue?vue&type=template&id=6125b9d0&scoped=true"
import script from "./DailyPublishQuotaNotice.vue?vue&type=script&lang=js"
export * from "./DailyPublishQuotaNotice.vue?vue&type=script&lang=js"
import style0 from "./DailyPublishQuotaNotice.vue?vue&type=style&index=0&id=6125b9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125b9d0",
  null
  
)

export default component.exports